/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import track from 'react-tracking';

function CourseOutcomes({ outcome }) {
  return <div className="mt-2 html-data" dangerouslySetInnerHTML={{ __html: outcome }} />;
}

CourseOutcomes.propTypes = {
  outcome: PropTypes.string.isRequired,
};

export default track({
  component: 'course-outcomes',
})(CourseOutcomes);
